
import { createStandardColumnSuggestions } from './Utils/EkonomiskAnalysEditColumnSuggestionUtils';
import EkonomiskAnalysEditColumnAutosuggest from './EkonomiskAnalysEditColumnAutosuggest';
import { IFieldError } from '../../../../../../../../../../../../Types/FormTypes';
import { EkonomiskAnalysStandardColumnQuery_ekanalysstandardcolumns } from '../Queries/EkonomiskAnalysEditColumnOriginQuery/_QueryTypes/EkonomiskAnalysStandardColumnQuery';
import { ValueType } from '../../../../../../../../../../../../Utils/Formatters/FormatterTypes';

interface IProps {
  columnChange: (newValue: string | null) => void;
  standardColumns?: EkonomiskAnalysStandardColumnQuery_ekanalysstandardcolumns[];
  value: any;
  onChange: (value: any) => void;
  onBlur: (value?: ValueType) => void;
  touched: boolean;
  fieldErrors?: IFieldError[];
}

const EkonomiskAnalysStandardColumnField: React.FunctionComponent<
  React.PropsWithChildren<IProps>
> = props => (
  <EkonomiskAnalysEditColumnAutosuggest
    label="Kolumn hämtas från"
    value={props.value ? props.value : undefined}
    onChange={props.columnChange}
    onBlur={props.onBlur}
    touched={props.touched}
    fieldErrors={props.fieldErrors}
    suggestions={
      props.standardColumns != null
        ? createStandardColumnSuggestions(props.standardColumns)
        : []
    }
    fullWidth
  />
);

export default EkonomiskAnalysStandardColumnField;
